import { ReservationStatuses } from '@/helpers/enums/reserveStatuses'
import { FECTH_TRIPS_LIST } from '../actions/types'

export interface TripsProps {
  data?: TripsReserveType[] | null
  meta?: Meta
  loading: boolean
}
interface Meta {
  current_page: number
  last_page: number
}

export interface TripsReserveType {
  reserve_id: string
  is_mid_term: number
  created_at: string
  guests_count: number
  checkin_to_checkout: string
  checkin: string
  can_chat: boolean
  checkout: string
  expired_at: string
  expired_at_timestamp: number
  extra_person_count: number
  normal_person_count: number
  expected_time_to_respond: string
  status: Status
  user_host: UserHost
  invoice: Invoice
  house: House
  review?: Review
}

interface House {
  cover_photo: string
  location?: Location
  province: string
  title: string
  city: string
  id: number
}

interface Review {
  is_storeable: boolean
  is_updateable: boolean
  is_submitted?: boolean
}

interface Location {
  latitude: string
  longitude: string
}

interface Invoice {
  price: Price
  id: string
}

interface Price {
  amount: number
  currency_name: string
  currency_short_form: string
}

interface Status {
  state: ReservationStatuses
  actor?: 'host' | 'guest' | null
}

interface UserHost {
  id: string
  fullname: string
  mobile?: string
  picture: string
}

interface TripsAction extends TripsProps {
  type: string
}

const initialTripsState: TripsProps = {
  loading: true,
  data: [],
  meta: {
    current_page: 1,
    last_page: 1,
  },
}

export const tripsReducer = (
  state: TripsProps = initialTripsState,
  { type, meta, data, loading }: TripsAction,
) => {
  switch (type) {
    case FECTH_TRIPS_LIST:
      return { meta, data, loading }

    default:
      return state
  }
}
